import { useEffect, useState } from "react"
import { fetchGet } from "../../hooks/fetch";

// export const NoticeSearchType = {
//     // ['전 체', '일반', '구인/구직', '기타']
//     ALL: "전 체",
//     GENERAL: "일 반",
//     FINDING: "구인/구직",
//     ETC: "기 타",
//     undefined: "",
// }

export const useNoticeCategories = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        fetchGet(
            `/notice/category/list`,
            (json) => setCategories(json.list)
        );
    }, []);

    return categories;
}